/**
 * The `brandIds` query parameter shared by every aggregate-aware list endpoint.
 * The backend validates it as a repeated key (`?brandIds=a&brandIds=b`) and answers
 * 400 BRAND_NOT_IN_SCOPE for anything outside the session catalogue.
 */

/** Appends one `brandIds` entry per id. Undefined/empty appends nothing (= all in scope). */
export function appendBrandIds(params: URLSearchParams, brandIds: string[] | undefined): void {
  if (!brandIds || brandIds.length === 0) return;
  for (const id of brandIds) params.append('brandIds', id);
}
